import React from 'react';
import {
  UPSERT_INCOME_FORM_ID,
  UpsertIncomeFormProps,
} from '../../components/UpsertIncomeModal/UpsertIncomeModal.meta';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { RealEstateEmpty } from '../../tables/RealEstate/RealEstate.empty';
import { useRealEstateForm } from './useRealEstateForm';
import { RealEstateFormFields } from './RealEstateFormFields';

export type Props = UpsertIncomeFormProps;

export const RealEstateForm = ({
  clientId,
  income,
  data,
  onSuccess,
  workflowProps,
  readOnly,
}: Props) => {
  const {
    data: { formBag, defaultShowAdvanced, mutationBag },
    actions: { onSubmit },
  } = useRealEstateForm({ clientId, income, onSuccess, data, readOnly });

  const {
    formState: { errors },
    clearErrors,
  } = formBag;

  const formValidationError = errors.StartAge?.message;

  const { Options: options } = data;
  const { RealEstateAssetOptions } = options;

  if (RealEstateAssetOptions.length === 0) {
    return <RealEstateEmpty clientId={clientId} workflowProps={workflowProps} />;
  }

  return (
    <form
      onSubmit={onSubmit}
      id={UPSERT_INCOME_FORM_ID}
      css={`
        display: flex;
        flex-direction: column;
        gap: 16px;
      `}
      aria-label="Real Estate income form"
    >
      {formValidationError && (
        <Alert
          variant="error"
          message={formValidationError}
          onRequestClose={() => clearErrors('StartAge')}
        />
      )}

      {mutationBag.error && (
        <Alert
          variant="error"
          message={mutationBag.error.message}
          onRequestClose={mutationBag.reset}
        />
      )}

      <RealEstateFormFields
        formBag={formBag}
        options={data.Options}
        defaultShowAdvanced={defaultShowAdvanced}
      />
    </form>
  );
};
